import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useTranslatedActivityType } from "PFApp/activities/show/hooks/use_translated_activity_type";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { ActivityHistoryProfile } from "PFCore/services/activity";
import { ActivityEvent, Profile } from "PFTypes";
import { useTranslation } from "react-i18next";

import { HistoryEntryDataPlaceholder } from "./history_entry_data_placeholder";
import { HistoryEntryProfile } from "./history_entry_profile";
import { HistoryEntryRow } from "./history_entry_row";

export type HistoryEntryHeaderProps = {
  profile: Profile | ActivityHistoryProfile | undefined;
  isLoading: boolean | undefined;
} & Pick<ActivityEvent, "event" | "createdAt">;

export const HistoryEntryHeader = ({ profile, event, createdAt, isLoading }: HistoryEntryHeaderProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.history" });
  const { formatDateTime } = useDateFormatter();
  const activity = useCurrentActivity();
  const activityType = useTranslatedActivityType(activity);

  if (isLoading) {
    return <HistoryEntryDataPlaceholder height="40px" />;
  }

  if (!profile) {
    return null;
  }

  return (
    <HistoryEntryRow>
      <HistoryEntryProfile
        profile={profile}
        subtitle={t(`entry.message.${event}` as unknown as TemplateStringsArray, {
          activityType,
          date: formatDateTime(createdAt)
        })}
      />
    </HistoryEntryRow>
  );
};
